
import React, { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

function getColor(lead){
  if(lead.dnc) return 'purple';
  if(!lead.dateCalled) return 'default';
  const called=new Date(lead.dateCalled); const now=new Date();
  const diffDays=Math.floor((now-called)/(1000*60*60*24));
  if(diffDays<=0) return 'green';
  if(diffDays<=7) return 'yellow';
  return 'red';
}
function formatDateTime(iso){ try{return new Date(iso).toLocaleString();}catch{return '';} }

export default function LeadCard({ lead, onEdit, onDelete }){
  const color = getColor(lead);
  const [newNote,setNewNote]=useState(''); const [editingIndex,setEditingIndex]=useState(-1); const [editingText,setEditingText]=useState('');
  const notes = Array.isArray(lead.notes)?lead.notes:[];
  const saveNotes=async(next)=>{
    try{await updateDoc(doc(db,'leads',lead.id),{notes:next,updatedAt:new Date().toISOString()});}
    catch(e){console.error(e);alert('Error updating notes.');}
  };
  const addNote=async()=>{
    const text=newNote.trim(); if(!text) return;
    const note={text, date:new Date().toISOString()}; const next=[note,...notes].slice(0,3);
    await saveNotes(next); setNewNote('');
  };
  const startEditNote=(i)=>{setEditingIndex(i); setEditingText(notes[i].text);};
  const cancelEditNote=()=>{setEditingIndex(-1); setEditingText('');};
  const saveEditNote=async()=>{
    if(editingIndex<0) return; const updated=[...notes]; updated[editingIndex]={...updated[editingIndex], text:editingText, date:new Date().toISOString()};
    await saveNotes(updated.slice(0,3)); cancelEditNote();
  };
  const deleteNote=async(i)=>{
    if(!window.confirm('Delete this note?')) return;
    const next=notes.filter((_,idx)=>idx!==i); await saveNotes(next);
    if(editingIndex===i) cancelEditNote(); else if(editingIndex>i) setEditingIndex(editingIndex-1);
  };

  return(<div className={`lead ${color}`}>
    <div className='lead-head'>
      <div>
        <div className='lead-name'>{lead.name}</div>
        <div className='lead-company'>{lead.company}{lead.location?` • ${lead.location}`:''}</div>
      </div>
      <div className='lead-actions'>
        <button onClick={onEdit}>Edit</button>
        <button title='Delete Lead' onClick={onDelete}>🗑️</button>
      </div>
    </div>
    <div className='lead-body'>
      {lead.position&&<div className='meta'>{lead.position}</div>}
      {lead.phone&&<div className='meta'>{lead.phone}</div>}
      {lead.email&&<div className='meta'>{lead.email}</div>}
      {lead.beltType&&<div className='meta'>Belt: {lead.beltType}</div>}
      <div className='meta muted'>Last Called: {lead.dateCalled? String(lead.dateCalled).split('T')[0]:'-'}</div>
      <div className='meta muted'>Updated: {formatDateTime(lead.updatedAt)}</div>

      <div className='notes'>
        <div className='notes-title'>Notes (keeps 3)</div>
        {notes.length===0 && <div className='empty'>No notes yet.</div>}
        {notes.map((n,i)=>(
          <div key={i} className='note'>
            {editingIndex===i?(
              <div className='note-edit'>
                <textarea value={editingText} onChange={e=>setEditingText(e.target.value)} />
                <div className='note-actions'>
                  <button className='btn tiny primary' onClick={saveEditNote}>Save</button>
                  <button className='btn tiny' onClick={cancelEditNote}>Cancel</button>
                </div>
              </div>
            ):(
              <>
                <div className='note-text'>{n.text}</div>
                <div className='note-meta'>{new Date(n.date).toLocaleString()}</div>
                <div className='note-actions'>
                  <button className='btn tiny linklike' onClick={()=>startEditNote(i)}>Edit</button>
                  <button className='btn tiny linklike' onClick={()=>deleteNote(i)}>Delete</button>
                </div>
              </>
            )}
          </div>
        ))}
        <div className='note-add'>
          <textarea placeholder='Add a note…' value={newNote} onChange={e=>setNewNote(e.target.value)} />
          <button className='btn small primary' onClick={addNote}>Add Note</button>
        </div>
      </div>
    </div>
    <div className='lead-foot'>
      Date Called: {lead?.dateCalled ?? '—'}
    </div>
  </div>);
}
